import React from "react";
import EOpticAndCameraFeature from "../../../../Model/EOpticAndCameraFeature";
import {
  PsrCaptureProfile,
} from "../../../../Model/CaptureProfile";
import { BasicControl } from "../../../Imager/ImagerFeatureControls";
import { Focus } from "../../../../Model/PsrCapabilites";

type FocusControlProps = {
  disabled: boolean;
  focus: Focus;
  captureProfile: PsrCaptureProfile;
  onChange: (value: { focus: number }) => void;
};

export function PsrFocusControl({ focus, captureProfile, disabled, onChange }: FocusControlProps) {
  if (captureProfile.focus == null) {
    throw new Error("Capture profile Focus is null");
  }
  return (
    <BasicControl
      disabled={disabled}
      feature="Focus"
      id={"PsrCameraControlFocus"}
      min={focus.minFocus}
      max={focus.maxFocus}
      value={captureProfile.focus}
      onValueChanged={(id, value) => {
        onChange({
          focus: value,
        });
      }}
      unit="x"
      step={1}
    />
  );
}
